import { MATERIAL_LIST_SCOPE } from "@msys/textutils";
import { AvailableReplacementsModal } from "../documents/AvailableReplacementsModal.js";

interface Props {
  handleClose(): void;
}

export function BillOfMaterialsTextsAvailableReplacementsModal({
  handleClose,
}: Props) {
  return (
    <AvailableReplacementsModal
      scope={MATERIAL_LIST_SCOPE}
      handleClose={handleClose}
    />
  );
}
